import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#f7f9f9',
    color100: '#f0f3f3',
    color200: '#e1e7e8',
    color300: '#d9e1e2',
    color400: '#b8bdbf',
    color500: '#97999b',
    color600: '#75787b',
    color700: '#53565a',
    color800: '#37393c',
    color900: '#1c1d1e'
  },
  default: {
    color50: '#d5e3e9',
    color100: '#aac7d3',
    color200: '#80acbe',
    color300: '#5590a8',
    color400: '#2b7492',
    color500: '#00587c',
    color600: '#004663',
    color700: '#00354a',
    color800: '#002332',
    color900: '#001219'
  },
  accent: {
    color50: '#eef8fc',
    color100: '#ddf1f8',
    color200: '#ccebf5',
    color300: '#bbe4f1',
    color400: '#aaddee',
    color500: '#99d6ea',
    color600: '#7aabbb',
    color700: '#5c808c',
    color800: '#3d565e',
    color900: '#1f2b2f'
  },
  positive: {
    color50: '#e1f4d5',
    color100: '#c2e9aa',
    color200: '#a4de80',
    color300: '#85d355',
    color400: '#67c82b',
    color500: '#84bd00',
    color600: '#3a9700',
    color700: '#2b7100',
    color800: '#1d4c00',
    color900: '#0e2600'
  },
  negative: {
    color50: '#f7e0da',
    color100: '#e7c1b5',
    color200: '#e7a290',
    color300: '#df836a',
    color400: '#d76445',
    color500: '#cf4520',
    color600: '#a6371a',
    color700: '#7c2913',
    color800: '#531c0d',
    color900: '#290e06'
  },
  special: {
    color50: '#d5edf4',
    color100: '#aadbe9',
    color200: '#80c9de',
    color300: '#55b6d2',
    color400: '#2ba4c7',
    color500: '#0092bc',
    color600: '#007596',
    color700: '#005871',
    color800: '#003a4b',
    color900: '#001d26'
  }
};

const variant: ACPVariant = {
  id: 'business.netspend.com',
  productTitle: 'Account Center',
  productType: 'biz',
  accessDomain: {
    subdomain: 'business',
    domain: 'netspend',
    topLevelDomain: 'com'
  },
  colors,
  legacyAcpTheme: 'netspend-small-business',
  legacyAcpBrandName: 'netspendbusiness',
  legacyLegosTheme: 'netspend-small-business',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'dark',
  contactInfo: {
    name: 'Netspend Corporation',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@netspend.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '1-86-NETSPEND (1-866-387-7363)',
    phone: '1-866-387-7363',
    phone_international: '737-220-8956',
    balance_check_phone: '8663877363',
    balance_check_phone_formatted: '1-866-387-7363',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: true,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: true,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: true
    },
    misc: {
      layoutComponentOverride: 'smallbiz',
      layoutAppBarInverted: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#0092BC',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.netspend.com/small-business',
      marketingSiteLinkText: 'Netspend.com',
      locationSearchMax: '25',
      iOSAppId: '1122232949'
    },
    content: {
      signUpContent: "Don't have a card? Sign up today."
    },
    disclaimers: {},
    sections: [
      'dashboard',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'move-money-subaccount',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
